import emma from '@/common/services/Emma'

const NewsResource = {
	getAllNews () { return emma.get('api/news') },
	shareNews (data) { return emma.post('api/news/share', data) }
}

export default NewsResource



// WEBPACK FOOTER //
// ./src/common/resources/News.js